(function () {
    'use strict';

    angular
        .module('surveyCampaignsModule')
        .controller('SurveyCampaignQuestionEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$window', 'questionnaireTemplate', 'questionnaireSection',
        'oddQuestion', 'oddQuestionFieldTypes','campaign'];

    function Controller($scope, $state, $window, questionnaireTemplate, questionnaireSection, oddQuestion,
                        oddQuestionFieldTypes,campaign) {

        $window.scrollTo(0, 0);
        $scope.campaign = campaign;
        $scope.questionnaireTemplate = questionnaireTemplate;
        $scope.questionnaireSection = questionnaireSection;
        $scope.oddQuestionFieldTypes = oddQuestionFieldTypes;

        $scope.ctrlCtxt = {};
        $scope.ctrlCtxt.questionnaireTemplateQuestion = oddQuestion;
        // Go To Survey Campaign
        $scope.goToSurveyCampaign = function () {
            $state.go('odd.surveyCampaignEdit', { ODDCampaignID: campaign.ODDCampaignID }, { reload: true });
        };

        // Go To Survey Campaign Section
        $scope.goToSurveySection = function () {
            $state.go('odd.surveyCampaignEdit.section', {
                ODDSectionID: questionnaireSection.ODDSectionID,
                ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID
            }, { reload: true });
        };

        $scope.goToCampaigns = function () {
            $state.go('odd.surveyCampaigns', { ODDBusinessUnitID: $scope.campaign.ODDBusinessUnitID }, { reload: true });
        };
     

    }
})();